module.exports = __webpack_public_path__ + "277b7f436109fcb713c1ddf45aa0fec0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/overages-shortages-unread.svg
// module id = 111
// module chunks = 0